<template>
  <Layout>
    <div style="display: flex">
      <div
        style="width: 300px; flex: none; margin-right: 1.5rem; max-height: 80vh;min-height:800px"
        class="card overflow-auto"
      >
        <equipSearchTree
          @treeChange="setEventsList"
          v-model:isShowDetail="isShowDetail"
          v-model:page="page"
          v-model:perPage="perPage"
          :key="key"
        />
      </div>
      <div style="flex: auto">
        <div class="card">
          <div class="card-body">
            <!-- search-part -->
            <!-- <Search v-model:tableData="tableData" @handleSearch="handleSearch" :originData="originData" :searchInfo="searchInfo" :id="telemetryInfo.id"></Search> -->
            <div style="margin-bottom: 2.5rem">
              <form>
                <div class="d-flex">
                  <div style="width: 300px">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        :placeholder="this.$t('page.health-monitoring.search')"
                        v-model="searchInfo.keyword"
                        @keydown="handleSearch"
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>

                  <div class="ms-5 me-5">
                    <div class="d-flex align-items-center">
                      <span class="me-1">{{this.$t('page.event-management.EventType')}}</span>
                      <div style="min-width: 150px">
                        <Multiselect
                          mode="tags"
                          v-model="searchInfo.level"
                          :close-on-select="false"
                          :searchable="true"
                          :canClear="true"
                          :placeholder="this.$t('page.all')"
                          :options="eventTypeList"
                          :noOptionsText="this.$t('page.NoOption')"
                          :noResultsText="this.$t('page.NoResultFound')"
                          @change="typeChanged($event)"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="d-flex align-items-center">
                      <span class="me-1">{{this.$t('page.event-management.EventStatus')}}</span>
                      <div style="min-width: 150px">
                        <Multiselect
                          mode="tags"
                          v-model="searchInfo.status"
                          :close-on-select="true"
                          :searchable="true"
                          :canClear="true"
                          :placeholder="this.$t('page.all')"
                          :options="eventStateList"
                          :noOptionsText="this.$t('page.NoOption')"
                          :noResultsText="this.$t('page.NoResultFound')"
                          @change="stateChanged($event)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- table-part -->
            <div class="position-relative">
              <div class="part-loading text-primary" v-show="isLoading">
                <div class="spinner-border mb-1" role="status"></div>
                <div>{{this.$t('base.loading')}}</div>
              </div>
              <div
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
              >
                <Table
                  :column="column"
                  :tableData="tableData"
                  :actionIcon="actionIcon"
                  :allChecked="allChecked"
                  v-model:singleData="singleData"
                  v-model:formType="formType"
                  @checkAllChanged="checkAllChanged"
                  @singleChecked="singleChecked"
                  @getEventsDetailInfo="getEventsDetailInfo"
                  @changeStatus="changeStatus"
                  @changeMoreStatus="changeMoreStatus"
                ></Table>
              </div>
              <div :class="[isLoading && 'visually-hidden']">
                <Empty v-if="!tableData.length" :content="emptyContent"></Empty>
                <!-- paginate-part-->
                <Pagination
                  v-else
                  class="me-3"
                  v-model:page="page"
                  v-model:perPage="perPage"
                  :pages="pages"
                  :prePageOption="prePageOption"
                  :tab_info_length="count"
                ></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Detail
      v-if="isShowDetail"
      :singleData="singleData"
      v-model:isShowDetail="isShowDetail"
      @freshKey="freshKey"
      :isMeasure="isMeasure"
      :sysList='sysList'
      @handleAlert="handleAlert"
      @getEventsDetailInfo="getEventsDetailInfo"
      @setEventsList="setEventsList"
      @freshPage="freshPage"
    ></Detail>
  </Layout>
  <message-alert :alertInfo="alertInfo" v-if="isShowAlert"></message-alert>
</template>

<script>
import { eventTypeList, eventStateList } from "@/utils/selectText.js";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@/default.scss";
import Layout from "@/layouts/main.vue";
import i18n from "@/i18n";
// import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import equipSearchTree from "../../components/equipSearchTree.vue";
// import Search from "./search"
import Table from "./table";
import Empty from "@/components/common/Empty";
import Pagination from "@/components/common/Pagination.vue";
import Detail from "./detail.vue";
import _ from "loadsh";
import Swal from "sweetalert2";
import {
  getEventsList,
  getEventsDetail,
  putEventBasicInfo,
} from "@/service/index.js";
// import {getEventsList,getInstancesDetailId,getEventsDetail,putEventBasicInfo} from "@/service/index.js"
import qs from "qs";

export default {
  page: {
    title: i18n.global.t('menu.intelligent-operation-maintenance.event'),
    meta: [{ tag: 0, name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    // PageHeader,
    equipSearchTree,
    // Search,
    Multiselect,
    Table,
    Empty,
    Detail,
    Pagination,
  },
  data() {
    return {
      title: this.$t('page.event-management.EventList'),
      items: [
        {
          text: this.$t('menu.intelligent-operation-maintenance.event'),
          href: "/iot/event-management",
        },
        {
          text: this.$t('page.event-management.EventList'),
          active: true,
        },
      ],
      column: [
        { dataIndex: "readableNo", title: this.$t('page.event-management.EventNumber') },
        { dataIndex: "createdAt", title: this.$t('page.event-management.OccurrenceTime') },
        { dataIndex: "level", title: this.$t('page.event-management.EventType') },
        { dataIndex: "device_name", title: this.$t('page.work-order.device-name') },
        { dataIndex: "root_sn", title: this.$t('page.pump_head_serial_number') },
        { dataIndex: "group_sn", title: this.$t('page.unit_serial_number') },
        { dataIndex: "measure_name", title: this.$t('page.health-monitoring.measuring_point_name') },
        { dataIndex: "updatedAt", title: this.$t('page.event-management.UpdateTime') },
        { dataIndex: "status", title: this.$t('page.event-management.status') },
      ],
      actionIcon: [
        {
          textType: "primary",
          iconClass: "ri-eye-fill",
          type: "view",
        },
      ],
      isLoading: false,
      tableData: [],
      originData: [],
      singleData: {},
      deviceInfo: {},
      telemetryInfo: {},
      measureobj: {},
      eventTypeList,
      eventStateList,
      searchInfo: {
        keyword: null,
        status: [],
        level: [],
        kind: "",
      },
      formType: null,
      isShowForm: false,
      isShowDetail: false,
      flag: null, //判断左侧树结构点击的是设备还是测量值
      deviceId: null,
      /* 分页 */
      page: 1,
      perPage: 20,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      count: 0,
      totalPage: 0,
      allChecked: false,
      alertInfo: {
        variant: "danger",
        content: this.$t('page.event-management.RequestFailedPleaseTryAgain'),
        icon: "ri-error-warning-line",
      },
      isShowAlert: false,
      emptyContent: this.$t('base.no-data'),
      key: 0, //点击详情中“事件库”后跳转，刷新树结构,
      result: {},
      sysList:[],
    };
  },
  watch: {
    tableData: {
      handler() {
        /* const totalPage = Math.ceil(newVal.length / this.perPage) // 总页数
        this.page = this.page > totalPage ? totalPage : this.page
        this.page = this.page < 1 ? 1 : this.page */
        this.setPages();
      },
      deep: true,
      immediate: true,
    },
    telemetryInfo: {
      handler(newVal, oldVal) {
        if (newVal.id != oldVal.id) {
          // this.searchInfo = {}
          this.allChecked = false;
        }
      },
    },
    page() {
      this.allChecked = false;
      this.setEventsList(
        this.telemetryInfo,
        this.deviceId,
        this.flag,
        this.measureobj
      );
    },
    perPage(val) {
      if (val) {
        this.page = 1;
        this.allChecked = false;
        this.setEventsList(
          this.telemetryInfo,
          this.deviceId,
          this.flag,
          this.measureobj
        );
        // this.setPages();
        // this.paginate(this.tableData);
      }
    },
  },
  methods: {
    freshKey() {
      this.key++;
    },
    freshPage() {
      this.setEventsList(
        this.telemetryInfo,
        this.deviceId,
        this.flag,
        this.measureobj
      );
    },
    lookForAllId(data = [], arr = []) {
      for (let item of data) {
        arr.push(item.id);
        if (item.children && item.children.length)
          this.lookForAllId(item.children, arr);
      }
      return arr;
    },
    lookInfo(shadowId, data, measurekey) {
      data.map((item) => {
        if (item.id === shadowId) {
          _.get(item, ["attributes", "attributes"]).map((attr) => {
            if (attr.group == '设备出厂信息' || attr.group == '设备管理信息') {
              this.result[attr.name] = attr.value;
            }
          });
          _.get(item, ["attributes", "measurements"]).map((meas) => {
            if (measurekey === meas.key) {
              this.result["measure_name"] = meas.name;
              this.result["measure_key"] = meas.key;
              this.result["suggestion"] = meas.suggestion || "";
              this.result["instruction"] = meas.instruction || "";
              this.result["measure_info"] = meas;
            }
          });
        } else {
          if (item.children && item.children.length) {
            this.lookInfo(shadowId, item.children, measurekey);
          }
        }
      });
      return this.result;
    },
    getArr(data) {
      let result = [];
      let queue = data;
      let list = [];
      while (queue.length > 0) {
        [...queue].forEach((child) => {
          queue.shift();
          list.push(child);
          result = result.concat([child]);
          child.children && queue.push(...child.children);
        });
      }
      return list;
    },
    setEventsList(telemetryInfo, deviceId, flag, measureobj) {
      this.telemetryInfo = telemetryInfo;
      this.measureobj = measureobj;
      this.deviceId = deviceId;
      this.flag = flag;
      this.isLoading = true;
      this.tableData = [];
      this.originData = [];
      this.searchInfo["kindAndLevel"] = [];
      if (typeof this.searchInfo.level != "string") {
        this.searchInfo.level = this.searchInfo.level.map((item) => {
          if (item == "AIWARNING") {
            this.searchInfo["kindAndLevel"].push(
              "TIME_BASED_DYTHRESHOLD_PREDICATE" + "+" + "WARNING"
            );
          } else {
            this.searchInfo["kindAndLevel"].push(
              "TIME_BASED_PREDICATE" + "+" + item
            );
          }
          return item;
        });
      } else {
        if (this.searchInfo.level == "AIWARNING") {
          this.searchInfo["kindAndLevel"].push(
            "TIME_BASED_DYTHRESHOLD_PREDICATE" + "+" + "WARNING"
          );
        } else {
          this.searchInfo["kindAndLevel"].push(
            "TIME_BASED_PREDICATE" + "+" + this.searchInfo.level
          );
        }
      }
      let data =
        flag === "device"
          ? {
              shadowId: this.lookForAllId([telemetryInfo]),
              page: this.page - 1,
              limit: this.perPage,
              kindAndLevel: this.searchInfo["kindAndLevel"],
              status: this.searchInfo["status"],
              keyword: this.searchInfo["keyword"],
            }
          : {
              telemetry: measureobj.key || "",
              page: this.page - 1,
              limit: this.perPage,
              shadowId: deviceId,
              kindAndLevel: this.searchInfo["kindAndLevel"],
              status: this.searchInfo["status"],
              keyword: this.searchInfo["keyword"],
            };
       this.sysList = [
        telemetryInfo,
        ...this.recursionArrSys(_.cloneDeep(telemetryInfo.children)),
      ];
      let params = qs.stringify(data, { arrayFormat: "repeat" });

      getEventsList(params)
        .then((res) => {
          if (res.payload) {
            let list = [];
            this.result = {};
            this.count = res.payload.count;
            this.totalPage = res.payload.totalPage;
            list = res.payload.data;
            if (!list.length) {
              this.isLoading = false;
              this.emptyContent =
                flag === "device" ? this.$t('page.event-management.DeviceHasNoEventRecord') : this.$t('base.no-data');
              return;
            }
            list.map((s) => {
              let info = this.lookInfo(
                s.forDeviceList[0].shadowId,
                [telemetryInfo],
                s.forDeviceList[0].telemetries[0]
              );
              if (this.sysList) {
                this.sysList.map((item) => {
                  if (item.id == s.forDeviceList[0]["shadowId"]) {
                    s["device_name"] = item.name;
                  }
                });
              } else {
                s["device_name"] = s.forDeviceList[0].name.split("$")[0];
              }
              s["deviceId"] = s.forDeviceList[0].shadowId;
              s["measure_info"] = info.measure_info;
              s["measure_name"] = info.measure_name;
              s["measure_key"] = info.measure_key;
              s["suggestion"] = info.suggestion;
              s["instruction"] = info.instruction;
              s['机组名称'] = info['机组名称'];
              s['设备所在区域'] = info['设备所在区域'];
              s["root_sn"] = telemetryInfo.root_sn
              s["group_sn"] = telemetryInfo.group_sn
              
              /* let forDeviceList = s.forDeviceList[0]
            s[item.name] = item.value;
              s['measure_name'] = telemetryInfo.name;
              s['measure_key'] = telemetryInfo.key;
              s['suggestion'] = telemetryInfo.suggestion;
              s['instruction'] = telemetryInfo.instruction;
              s['deviceId'] = forDeviceList.shadowId;
              s['device_name'] = forDeviceList.name.split("$")[0];
              s['measure_info'] = telemetryInfo//供跳转图谱分析页面使用
              s[item.name] = item.value
              if(flag === 'device'){
                let measureInfo = _.get(device.payload, ["attributes", "measurements"]).find(item=> {return item.key === forDeviceList.telemetries[0]})
                  s['measure_name'] = measureInfo ?measureInfo.name:"";
                  s['measure_key'] = measureInfo ?measureInfo.key:"";
                  s['suggestion'] = measureInfo ?measureInfo.suggestion:"";
                  s['instruction'] = measureInfo ?measureInfo.instruction:"";
                  s['measure_info'] = measureInfo ?measureInfo:{} //供跳转图谱分析页面使用
                } */
              s.checked = false;
            });
            this.tableData = list;
            this.originData = list;
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.handleAlert("danger", this.$t('page.event-management.FailedGetEventListPleaseTryAgain'));
        });
    },
    //获取最新设备名称
    recursionArrSys(data) {
      if (!data) return []
      let resultList = [];
      let queues = data;
      while (queues.length > 0) {
        [...queues].forEach((child) => {
          queues.shift();
          resultList = resultList.concat([child]);
          child.children && queues.push(...child.children);
        });
      }
      return resultList;
    },
    //获取事件详情
    getEventsDetailInfo(eventId, deviceInfo) {
      this.singleData = {};
      let params = {
        eventId,
        type: "OBJECT_ID",
      };
      getEventsDetail(eventId, params)
        .then((res) => {
          if (res.payload) {
            this.singleData = _.cloneDeep({ ...res.payload, ...deviceInfo });
          }
        })
        .catch(() => {
          this.handleAlert("danger", this.$t('page.event-management.FailedGetEventDetailPleaseTryAgain'));
        });
      this.isShowDetail = true;
    },
    //批量更改事件状态
    changeMoreStatus(status) {
      Swal.fire({ title: this.$t('page.event-management.BatchModification'), showConfirmButton: false });
      Swal.showLoading();
      let eventIds = this.tableData.filter((item) => {
        return item.checked;
      });
      let proList = [];
      eventIds.forEach((eve) => {
        proList.push(
          new Promise((resolve, reject) => {
            putEventBasicInfo(eve.id, {
              status,
              additionalInfo: eve.additionalInfo,
            })
              .then((res) => {
                return resolve(res);
              })
              .catch(() => {
                return reject(eve.readableNo);
              });
          })
        );
      });
      Promise.allSettled(proList).then((result) => {
        Swal.close();
        if (result.length) {
          let failList = result.filter((item) => {
            return item.status === "rejected";
          });
          if (failList.length) {
            let failNo = _.map(failList, "reason");
            Swal.fire(
              this.$t('page.event-management.BatchModifying'),
              `修改事件编号:${failNo} 的状态失败！`,
              "error"
            );
          } else {
            Swal.fire(this.$t('page.event-management.BatchModifying'), `批量修改事件状态成功`, "success");
          }
          this.setEventsList(
            this.telemetryInfo,
            this.deviceId,
            this.flag,
            this.measureobj
          );
        }
      });
    },
    //更改单个事件状态
    changeStatus(status, data) {
      let params = {
        status,
        additionalInfo: data.additionalInfo,
      };
      putEventBasicInfo(data.id, params)
        .then((res) => {
          if (res.payload) {
            this.handleAlert("success", this.$t('page.event-management.StatusChangedSuccessfully'), "ri-check-double-line");
            this.setEventsList(
              this.telemetryInfo,
              this.deviceId,
              this.flag,
              this.measureobj
            );
          }
        })
        .catch((err) => {
          console.log(err);

          this.handleAlert("danger", this.$t('page.event-management.FailedModifyStatusPleaseTryAgain'));
        });
    },
    typeChanged(ev) {
      this.searchInfo.level = ev;
      this.search();
    },

    stateChanged(ev) {
      this.searchInfo.status = ev;
      this.search();
    },
    handleSearch(e) {
      if (e.keyCode == 13) {
        e.cancelBubble = true;
        e.stopPropagation();
        e.preventDefault();

        this.search();
      }
    },
    //搜索
    search() {
      this.page = 1;
      this.perPage = 20;
      this.setEventsList(
        this.telemetryInfo,
        this.deviceId,
        this.flag,
        this.measureobj
      );
    },
    /* 筛选分页数据 */
    paginate(data) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return data.slice(from, to);
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.totalPage; index++) {
        this.pages.push(index);
      }
    },
    /* 表格全选 */
    checkAllChanged(allChecked) {
      this.allChecked = allChecked;
      this.tableData.forEach((item) => {
        item.checked = allChecked;
      });
    },
    /* 表格项单选 */
    singleChecked(id, checked) {
      let i = this.tableData.findIndex((item) => {
        return item.id == id;
      });
      if (i != -1) {
        this.tableData[i].checked = checked;
      }
      this.allChecked = this.tableData.every((item) => {
        return item.checked;
      });
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "3000"
    ) {
      this.isShowAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.isShowAlert = false;
      }, duration);
    },
    // 获取从设备全生命周期过来的事件详情
    getEventDetailFromLifecycle(eventDetailFromLifecycle) {
      if (eventDetailFromLifecycle) {
        eventDetailFromLifecycle = JSON.parse(eventDetailFromLifecycle)

        // this.sysList = [
        //   eventDetailFromLifecycle.deviceDetail,
        //   ...this.recursionArrSys(_.cloneDeep(eventDetailFromLifecycle.deviceDetail.children)),
        // ];

        let info = this.lookInfo(
            eventDetailFromLifecycle.forDeviceList[0].shadowId,
            [eventDetailFromLifecycle.deviceDetail],
            eventDetailFromLifecycle.forDeviceList[0].telemetries[0]
        );
        eventDetailFromLifecycle['device_name'] = eventDetailFromLifecycle['deviceDetail']['name']
        eventDetailFromLifecycle["deviceId"] = eventDetailFromLifecycle['deviceDetail']['id']
        eventDetailFromLifecycle["measure_info"] = info.measure_info;
        eventDetailFromLifecycle["measure_name"] = info.measure_name;
        eventDetailFromLifecycle["measure_key"] = info.measure_key;
        eventDetailFromLifecycle["suggestion"] = info.suggestion;
        eventDetailFromLifecycle["instruction"] = info.instruction;
        eventDetailFromLifecycle['机组名称'] = info['机组名称'];
        eventDetailFromLifecycle['设备所在区域'] = info['设备所在区域'];

        this.isShowDetail = true
        this.singleData = eventDetailFromLifecycle
      }
    }

  },
  mounted() {

    // 从设备全生命周期过来时，直接取对应的事件数据
    let eventDetailFromLifecycle = localStorage.getItem('eventDetail')
    if (eventDetailFromLifecycle) {
      this.getEventDetailFromLifecycle(eventDetailFromLifecycle)
      localStorage.removeItem('eventDetail')
      // return;
    }
    //处理初始化时，若未点击左侧树结构,但树结构已有active,则内容对应改变
    let deviceTreeActive = sessionStorage.getItem("deviceTreeActive") || "";
    let localStorageDevice = JSON.parse(localStorage.getItem("equipmentData"));
    if (deviceTreeActive && deviceTreeActive.includes("&&")) {
      //包含&&,树avtive是测点，反之是设备
      let deviceId = deviceTreeActive.split("&&")[0];
      let obj = sessionStorage.getItem("measureInfo")
        ? JSON.parse(sessionStorage.getItem("measureInfo"))
        : {};
      this.setEventsList(localStorageDevice, deviceId, "measure", obj);
    } else if (deviceTreeActive && !deviceTreeActive.includes("&&")) {
      this.setEventsList(localStorageDevice, deviceTreeActive, "device");
    }
  },
};
</script>
